export const formatCurrency = (v) => `${parseFloat(v || 0).toFixed(2)} \u20AC`;

export const formatDate = (d) => {
  if (!d) return '-';
  const p = d.split('-');
  return `${p[2]}/${p[1]}/${p[0]}`;
};

export const formatMonth = (m) => {
  if (!m) return '-';
  const [y, mo] = m.split('-');
  const months = ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'];
  return `${months[parseInt(mo)-1]} ${y}`;
};
